import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import Immutable from 'immutable';
import NavigationItemRecord from '../../../../../records/NavigationItemRecord';
export default function getClassicParentLink(link, childLinks) {
  // Commented properties are probably not needed but kept for reference
  var classicParentLink = {}; // classicParentLink.anchorTagAttributesAsString = ''

  classicParentLink.linkId = link.linkId || link.label.toUpperCase().replace(/ /g, '_');
  classicParentLink.linkName = link.label;
  classicParentLink.subLevelHierarchyList = Immutable.OrderedMap(childLinks);
  return [classicParentLink.linkId, NavigationItemRecord(classicParentLink)];
}